import { Theme } from '@mui/material/styles'

const muiBadge = (_theme: Theme) => {
  return {
    styleOverrides: {
      dot: {
        height: 10,
        width: 10,
        top: 5,
        right: 5
      }
    }
  }
}

export default muiBadge
